import { IClientCityBrief } from '@bustickus/models-client';

function getCityByIndex(cities: IClientCityBrief[], index: number): IClientCityBrief | null {
  if (cities.length > index) {
    return cities[index];
  }

  return null;
}

export default getCityByIndex;
